import Mustache from "mustache/mustache.mjs";
import { getFieldsFromTemplate } from "./useSeoFields.mjs";
import { stripTag } from "../utils/index.mjs";
export const useParseTemplate = (template, value) => {
  if ("string" !== typeof template) {
    return template;
  }
  const fields = getFieldsFromTemplate(template);
  if (fields?.length < 1) {
    return stripTag(template);
  }
  fields.map((field) => {
    template = template?.replace(field, `{${field}}`);
    console.log("field", field);
    if (value?.[field]) {
      value[field] = stripTag(value[field]);
    }
  });
  let rendered = Mustache.render(template, {
    ...value
  });
  rendered = stripTag(rendered);
  return rendered;
};
